<div class="search" #searchContainer>
  <div class="search__input">
    <ng-icon
      name="heroMagnifyingGlass"
      color="var(--primary-500)"
      size="24"
    ></ng-icon>
    <input
      placeholder="Busca por no. de catálogo, concepto, marcas, CAS"
      type="text"
      [(ngModel)]="searchTerm"
      (focus)="onFocusSearch()"
      (input)="onSearchTermChange($event)"
      (keydown.enter)="onEnter()"
    />
    <button class="search__input__close" *ngIf="isResultsVisible || (searchTerm?.length||0) > 0" (click)="onCloseSearch()">
      <ng-icon name="heroXMark" color="var(--primary-500)" size="19"></ng-icon>
    </button>
  </div>

  <div class="search__results" *ngIf="(isProductSearchActive$ | async) && (searchTerm?.length||0)>=MIN_SEARCH_LENGHT">
    <div class="search__results__group">
      <p class="search__results__group__title text-body-medium">
        Buscando productos
      </p>
    </div>
  </div>
  
  <div class="search__results" *ngIf="
        (isProductSearchActive$ | async)!==false && 
        isResultsVisible && 
        ((searchResults$ | async)?.length || 0) > 0 && 
        (searchTerm?.length||0) > 0
    ">
    
    <div
      class="search__results__group"
      *ngFor="let optionsGroup of (searchResults$ | async)"
    >
      <p class="search__results__group__title text-title-5">
        {{ optionsGroup.title }}
      </p>
      <ul
        class="search__results__group__items"
        *ngIf="optionsGroup.items.length > 0"
      >
        <li
          class="search__results__group__item text-body-medium text-neutral-800"
          *ngFor="let option of optionsGroup.items"
          [routerLink]="['/products', option.value]"
          (click)="onCloseSearch()"
        >
          {{ option.label }}
        </li>
      </ul>
      <div *ngIf="optionsGroup.items.length === 0">
        No se encontraron resultados
      </div>
    </div>
  </div>
</div>
